export function random(min, max) {
  return Math.floor(Math.random() * (max - min + 1) + min);
}

/**
 * Randomize array element order in-place.
 * Using Durstenfeld shuffle algorithm.
 */
export const shuffleArray = (array) => {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    const temp = array[i];
    array[i] = array[j];
    array[j] = temp;
  }
  return array;
};

/**
 * Parse JWT Token
 */
export function parseJwt(token) {
  try {
    return JSON.parse(
      Buffer.from(token.split(".")[1] || "", "base64").toString()
    );
  } catch (e) {
    return {};
  }
}

/**
 * 初始化 Google Analytics (gtag)。
 * 若 script 已存在則僅重新觸發 config，不重複插入 script 標籤。
 * @param {string} gId - GA4 Measurement ID，例如 "G-XXXXXXXXXX"
 */
export function initGtag(gId) {
  window.dataLayer = window.dataLayer || [];
  if (!window.gtag) {
    window.gtag = function () {
      window.dataLayer.push(arguments);
    };
  }
  if (!document.querySelector('script[src*="googletagmanager.com/gtag/js"]')) {
    const script = document.createElement("script");
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${gId}`;
    document.head.appendChild(script);
    window.gtag("js", new Date());
  }
  window.gtag("config", gId);
}
